import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { NonFloatingLabelProps } from './types';
import { getThemeFontColor } from './utils';

type FloatingLabelStyleProps = Pick<NonFloatingLabelProps, 'disabled' | 'hasError'>;

const styles = ({ disabled, hasError }: FloatingLabelStyleProps) => css`
  display: inline-block;
  color: ${getThemeFontColor({ theme, disabled, hasError })};
  font-size: ${theme.fontSize(16)};
  margin-bottom: ${theme.spacing(0.5)};
`;

export const NonFloatingLabelStyles = {
  nonFloatingLabel: (nonFloatingLabelProps: FloatingLabelStyleProps) => styles(nonFloatingLabelProps),
};
